module.exports = __webpack_public_path__ + "img/CE_Long-Logo_White_hi-res.7fe164e0.png";